import { Box, Stack } from "@mui/material";

import { Text } from "../../components/Text";
import downloadQr from "../../Login/assets/download-qr.webp";
import { getBackgroundMuted, getBorderBase, getMutedText, getStrongText } from "../themeHelpers";

interface HelpCenterMobileAppBannerProps {
  isMobile: boolean;
}

export function HelpCenterMobileAppBanner(props: HelpCenterMobileAppBannerProps) {
  const { isMobile } = props;

  return (
    <Stack
      alignItems="center"
      direction={isMobile ? "column" : "row"}
      spacing={isMobile ? 3 : 5}
      sx={(theme) => ({
        paddingTop: theme.spacing(5),
        paddingRight: theme.spacing(5),
        paddingBottom: theme.spacing(5),
        paddingLeft: theme.spacing(5),
        borderRadius: theme.borderRadius?.xLarge,
        backgroundColor: getBackgroundMuted(theme),
        border: `1px solid ${getBorderBase(theme)}`,
      })}
    >
      <Stack
        spacing={2}
        sx={{
          flex: 1,
          textAlign: isMobile ? "center" : "left",
          alignItems: isMobile ? "center" : "flex-start",
        }}
      >
        <Text
          bold
          variant="body1"
          sx={(theme) => ({
            fontFamily: theme.typography.body1.fontFamily,
            fontSize: isMobile ? theme.typography.h6.fontSize : theme.typography.h5.fontSize,
            lineHeight: 1.2,
            color: getStrongText(theme),
          })}
        >
          Take Clipboard with you
        </Text>
        <Text variant="body2" sx={(theme) => ({ color: getMutedText(theme), maxWidth: "28rem" })}>
          Download our mobile app to manage your schedule, post shifts, and message your workers on
          the go.
        </Text>
      </Stack>
      <Stack alignItems="center" spacing={1} sx={{ flexShrink: 0 }}>
        <Box
          component="img"
          src={downloadQr}
          alt="QR code to download the Clipboard mobile app"
          sx={(theme) => ({
            width: 128,
            height: 128,
            padding: theme.spacing(1),
            borderRadius: theme.borderRadius?.medium,
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${getBorderBase(theme)}`,
          })}
        />
        <Text variant="caption" sx={(theme) => ({ color: getMutedText(theme) })}>
          Scan to download
        </Text>
      </Stack>
    </Stack>
  );
}
